import {
  createThreadBehaviour,
  type ResponderDraftEvent,
} from './shared-responder-v2-core-thread-behaviour';
import { THREAD_KINDS } from './shared-responder-v2-core-thread.consts';
import type { ResponderAnswer } from './shared-responder-v2-core-thread.types';

export function emptyMessageDraft(): ResponderAnswer {
  return { kind: 'acknowledged', transcript: null };
}

export function reduceMessageDraft(
  draft: ResponderAnswer | null,
  event: ResponderDraftEvent
): ResponderAnswer | null {
  if (event.type === 'acknowledged') {
    return {
      kind: 'acknowledged',
      transcript: draft?.kind === 'acknowledged' ? draft.transcript : null,
    };
  }

  if (event.type === 'transcriptChanged') {
    return { kind: 'acknowledged', transcript: event.transcript };
  }

  return draft;
}

/**
 * A message is a read-only statement — Continue (or "I'm done") is its only
 * affordance, so acknowledging is always complete and every answering flag
 * stays off.
 */
export const MESSAGE_THREAD_BEHAVIOUR = createThreadBehaviour({
  kind: THREAD_KINDS.Message,
  isAnswerEditable: false,
  emptyDraft: emptyMessageDraft,
  reduceDraft: reduceMessageDraft,
  isDraftComplete: () => true,
  showsContinueButton: () => true,
});
